import { CheckedState } from "@radix-ui/react-checkbox";
import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface, VarKey } from "@swivl-mono/types";
import { Checkbox, RadioButtons } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import VarsModel from "../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const InputNode = {
  Type: "input",
  Empty: function () {
    return {
      id: RandomId(6),
      type: InputNode.Type,
      validationType: "none",
      showTyping: false,
      delay: 0,
      onCompleteGoto: null,
      ifInvalidGoto: null
    };
  },

  PlumbData: function (node: NodeInterface) {
    const tabs =
      node.validationType && node.validationType !== "none"
        ? [
            {
              id: "onCompleteGoto",
              source: "onCompleteGoto",
              target: node.onCompleteGoto,
              title: "Valid"
            },
            {
              id: "ifInvalidGoto",
              source: "ifInvalidGoto",
              target: node.ifInvalidGoto,
              title: "Invalid"
            }
          ]
        : [
            {
              id: "onCompleteGoto",
              source: "onCompleteGoto",
              target: node.onCompleteGoto
            }
          ];

    return TabNodeLayoutData({
      node: node,
      label: "Input",
      title: node.validationType && node.validationType !== "none" ? node.validationType : undefined,
      baseWidth: 150,
      tabs: tabs
    });
  },

  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.updateValidation = this.updateValidation.bind(this);
      this.saveToggled = this.saveToggled.bind(this);
      //  this.state = {selectedOption:this.props.node.validationType}
    }

    updateValidation(event: any) {
      var newVal = event.target.value;
      let node = JSON.parse(JSON.stringify(this.props.node));
      node.validationType = newVal;
      node.onCompleteGoto = "";
      node.ifInvalidGoto = "";
      this.props.updateNode(node, this.props.node, true);
    }

    saveToggled(checked: CheckedState) {
      if (!checked) {
        this.onChangeUpdateAndRedraw({ target: { name: "saveTo", value: undefined } });
        return;
      }

      let vars = VarsModel.variableOptions(true);

      if (!vars || vars.length === 0) {
        alert("User Variables Not Loaded");
        return;
      }
      var saveTo;
      for (var i = 0; i < vars.length; i++) {
        let val = vars[i].value;
        if (
          (val === VarKey.UserName && this.props.node.validationType == "name") ||
          (val === VarKey.UserEmail && this.props.node.validationType == "email") ||
          (val === VarKey.UserPhoneNumber && this.props.node.validationType == "phone")
        ) {
          saveTo = vars[i].value;
          break;
        }
      }

      if (!saveTo) {
        saveTo = vars[0].value;
      }

      this.onChangeUpdateAndRedraw({ target: { name: "saveTo", value: saveTo } });
    }
    render() {
      var saveToDropdown, isSaveTo, saveToCheckbox;
      if (this.props.node.saveTo) {
        isSaveTo = true;
        saveToDropdown = <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="saveTo" value={this.props.node.saveTo} />;
      } else {
        isSaveTo = false;
      }
      saveToCheckbox = (
        <div className="urlTarget">
          <span>Save to Variable</span>
          <Checkbox onCheckedChange={this.saveToggled} checked={isSaveTo} />
        </div>
      );

      return (
        <div>
          <div className="panel message_panel flex flex-col gap-2">
            <InspectorNodeHeader title="Input" />
            <div className="panelRow">
              Validation:
              <RadioButtons
                options={[
                  { value: "none", label: "None" },
                  { value: "name", label: "Name" },
                  { value: "email", label: "Email" },
                  { value: "phone", label: "Phone" },
                  { value: "zip", label: "Zip" }
                ]}
                name="validationType"
                value={this.props.node.validationType}
                onChange={this.updateValidation}
              />
            </div>
            {saveToCheckbox}
            {saveToDropdown}
          </div>
          <div className="carouselPadding"></div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default InputNode;
